module.exports = __webpack_public_path__ + "img/uvab.c92c2330.png";